import type { FaireProductEntity } from "../../entity_types/product";

export const p_bamndnk5xa: FaireProductEntity = {
  token: "p_bamndnk5xa",
  type: "product",
  name: "By the Sea - Hydrangea and Sea Salt Candle",
  brandToken: "b_aor6cery",
  brandName: "Ash & Rose",
  imageUrl:
    "https://cdn.faire.com/fastly/093c19dcfe2b5e7af5bdfcc0a533d957d38cca78032e1df717a8a7ebb0199c95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1aaacbe7200881c2bdaa5879dbbbe49566684f7a024e2b75d198f01cf91933f9.jpeg",
    "https://cdn.faire.com/fastly/a829d876fe72746c0769c9dc9a2a87a00a008821adc4d803f5d48f39065555ff.jpeg",
    "https://cdn.faire.com/fastly/326ae5a9e70d2b870f7abf0946906137ff018caa94421f292d6f82995655b44c.jpeg",
    "https://cdn.faire.com/fastly/9ce310e6ea917ff6c45f22fcd53df3b5f58ec208d9532aec1217d72dba15a7cb.jpeg",
    "https://cdn.faire.com/fastly/02eb8b189214184bc7a549b8c8a3e799a533d82a484d1d3718022105360a4c83.jpeg",
    "https://cdn.faire.com/fastly/7451166f831f2222c6c14a87e94accf2d17a9084733f42dc6b1e2a3297250283.jpeg",
    "https://cdn.faire.com/fastly/bdc00e4c156e11c77ebe8883f8f175e145d8cd38d87ce8265b73dc69318f38fe.jpeg",
    "https://cdn.faire.com/fastly/dbac6865e695ca5087c74841af699cf38d4092bf6dfc80674a95663350137f38.jpeg",
    "https://cdn.faire.com/fastly/ac7dd872b0113a9a8b01f565477b860446da2d5be74de4d0e3018652916c4b4b.jpeg",
    "https://cdn.faire.com/fastly/c9c25d9b0edabbc0033ea8a19d54bb1f8ef5c4868145b13f04729036aac26128.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Take a sensory escape to a coastal garden...\n\nTopped with dried blue hydrangea petals and a mix of sea salts, this dreamy candle features natural fragrance notes of salt, hydrangea, ozone, and freesia. Watch the salts gently melt away as the petals float on the surface of the liquid wax.\n\nFeatures hydrangeas grown locally in our own garden, along with coarse pacific sea salt and French sel gris for a fascinating mix of color and texture.\n\n100% soy wax candle, packaged in a rose gold tin with a clear window top. The tin is re-usable and perfect for storing small office supplies, hair accessories, or snacks!\n\nHandmade in the USA.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:01.384Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
